module.exports = __webpack_public_path__ + "img/02.a531c5d7.jpg";